import type { FilterState } from '../runtime/services/FilterService';

export const restoreState = (key: string, filter?: FormType<any>, pager?: Pager, columns?: Columns): void =>
{
    return useNuxtApp().$viewstate?.restore(key, filter, pager, columns);
};

export const persistState = (key: string, filter?: FormType<any>, pager?: Pager, columns?: Columns): void =>
{
    return useNuxtApp().$viewstate?.persist(key, filter, pager, columns);
};

export const setFilterState = (state: FilterState): void =>
{
    return useNuxtApp().$viewstate?.setFilterState(state);
};

export const getFilterState = (): FilterState =>
{
    return useNuxtApp().$viewstate?.getFilterState();
};

export const setColumnsState = (state: Columns): void =>
{
    return useNuxtApp().$viewstate?.setColumnsState(state);
};

export const getColumnsState = (): Columns =>
{
    return useNuxtApp().$viewstate?.getColumnsState();
};
